import type { FC, PropsWithChildren } from 'react'
import { useEffect } from 'react'

import type { MsdfConfig } from '../../../types'
import { FontAtlasContext, useConstructContext } from './context'
import { loadFontAtlasAsync } from './helpers'

type FontAtlasProps = {
  fontName: string
  fontConfig: MsdfConfig
}

export const FontAtlas: FC<PropsWithChildren<FontAtlasProps>> = ({
  fontName,
  fontConfig,
  children,
}) => {
  const context = useConstructContext()
  const {
    font: { setValue: setFont },
  } = context

  useEffect(() => {
    loadFontAtlasAsync(fontName, fontConfig).then(font => {
      setFont(font)
    })
  }, [fontConfig, fontName, setFont])

  return <FontAtlasContext.Provider value={context}>{children}</FontAtlasContext.Provider>
}
